export default "__VITE_ASSET__CM2kW3FJ__"